/**
 * Shared helpers for mapping toolset/tool status to MUI Chip color.
 * Used by ToolsetsTab and ToolsetDetailsDrawer for consistent status display.
 */

export type StatusChipColor = 'success' | 'warning' | 'primary' | 'disabled';

/**
 * Maps a status string (e.g. active, paused, init) to an MUI Chip color.
 * Normalizes input with toLowerCase() so 'Active' and 'ACTIVE' behave the same.
 */
export function getStatusChipColor(status: string): StatusChipColor {
  switch (status?.toLowerCase()) {
    case 'active':
      return 'success';
    case 'paused':
      return 'warning';
    case 'init':
      return 'disabled';
    default:
      return 'primary';
  }
}
